import { render, staticRenderFns } from "./LessonRequestForm.vue?vue&type=template&id=13cf839c&scoped=true&"
import script from "./LessonRequestForm.vue?vue&type=script&lang=js&"
export * from "./LessonRequestForm.vue?vue&type=script&lang=js&"
import style0 from "./LessonRequestForm.vue?vue&type=style&index=0&id=13cf839c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cf839c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VSelect,VTextarea})
